import React, { useState, useContext, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { CartContext } from '../../../components/cartContext';
import ThemeToggler from '../../../components/themeToggler';
import { ThemeContext } from '../../../components/themeContext';
import LogoIcon from '../../../assets/images/cloudVantage Logo.png';
import WhiteLogoIcon from '../../../assets/images/cloudVantage Logo White.png';
import icon from '../../../assets/images/cloudVantage Icon.png';
import WhiteIcon from '../../../assets/images/cloudVantage Icon White.png';
import cart from '../../../assets/svg-icons/cart.svg';
import menu from '../../../assets/svg-icons/menu.svg';
import menuWhite from '../../../assets/svg-icons/menuWhite.svg';
import menuBrand from '../../../assets/svg-icons/menuBrand.svg';
import projectsFolder from '../../../assets/svg-icons/folder.svg';
import close from '../../../assets/svg-icons/closeBrand.svg';
import arrow from '../../../assets/svg-icons/arrow.svg';
import logout from '../../../assets/svg-icons/logoutIcon.svg';
import hamburger from '../../../assets/svg-icons/hamburger-menu.svg';
import add from '../../../assets/svg-icons/addWhite.svg';
import { useDispatch, useSelector } from 'react-redux';
import Input from '../../../components/input';
import TextArea from '../../../components/textArea';
import Button from '../../../components/button';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import {
  createProject,
  listServers,
  listUserProjects,
  setSelectedProject,
  switchUserProject,
  createWhiteLabel,
} from '../../../hooks/local/userReducer';
import Spinner from '../../../components/spinner';
import { useServerList } from './resuableEffect';
import {
  showSuccessMessage,
  showErrorMessage,
  isDevelopment,
} from '../../../hooks/constants';
import { usePartner } from '../../../contexts/PartnerContext';
import {
  Database,
  Globe,
  Handshake,
  Logs,
  ServerCrash,
  FileLock2,
} from 'lucide-react';
import resources from '../../../assets/svg-icons/resources.svg';
import manage from '../../../assets/svg-icons/edit.svg';
import billing from '../../../assets/svg-icons/blackBilling.svg';
import support from '../../../assets/svg-icons/blackSupport.svg';
import setting from '../../../assets/svg-icons/blackSetting.svg';
import Select from '../../../components/select';
import { apiEndPoints } from '../../../hooks/remote/apiEndPoints';

const TopBar = () => {
  const dispatch = useDispatch();
  const userSessionData = useSelector((state) => state.user.userSessionData);

  const navigate = useNavigate();
  const { theme } = useContext(ThemeContext);
  const { totalPrice, currency } = useContext(CartContext);
  const {
    partnerInfo,
    currentSubdomain,
    loading: isLoading,
    switchToAdminMode,
    switchToCustomerView,
  } = usePartner();

  const [serviceVisible, setServiceVisible] = useState(false);
  const [projectsVisible, setProjectsVisible] = useState(false);
  const [smallScreenMenu, setSmallScreenMenu] = useState(false);
  const [addNewProjectDiv, setAddNewProjectDiv] = useState(false);
  const [becomeAgentModal, setBecomeAgentModal] = useState(false);
  const [createWhiteLabelModal, setCreateWhiteLabelModal] = useState(false);
  const [showPartnerAdminModal, setShowPartnerAdminModal] = useState(false);
  const [projectSwitchingModal, setProjectSwitchingModal] = useState(false);
  const [switchProgress, setSwitchProgress] = useState(0);
  const [switchingProjectName, setSwitchingProjectName] = useState('');
  const [zones, setZones] = useState([]);
  const [zonesLoading, setZonesLoading] = useState(false);
  const [zonesError, setZonesError] = useState('');
  const [selectedZone, setSelectedZone] = useState(null);
  const [zoneProjects, setZoneProjects] = useState([]);
  const [zoneProjectsLoading, setZoneProjectsLoading] = useState(false);

  const userProjectList = useSelector((state) => state.user.userProjectList);
  const selectedProject = useSelector((state) => state.user.selectedProject);
  const loading = useSelector((state) => state.user.loading);

  useEffect(() => {
    if (userProjectList && userProjectList.length > 0 && !selectedProject) {
      dispatch(setSelectedProject(userProjectList[0]));
    }
  }, [dispatch, userProjectList, selectedProject]);

 const handleProjectSelection = async (userSelectedProject) => {
  closeProjects();

  setSwitchingProjectName(userSelectedProject.name);
  setProjectSwitchingModal(true);
  setSwitchProgress(0);

  const progressInterval = setInterval(() => {
    setSwitchProgress((prev) => {
      if (prev >= 90) {
        clearInterval(progressInterval);
        return 90;
      }

      return prev + 3;
    });
  }, 1000);

  try {
    // FIRST: tell backend to switch project
    const result = await dispatch(
      switchUserProject(userSelectedProject.id)
    );

    const payload = result?.payload;

    if (payload?.statuscode !== "00") {
      throw new Error(
        payload?.statusmessage ||
        payload?.message ||
        "Failed to switch project"
      );
    }

    // SECOND: only update Redux after backend confirms switch
    dispatch(setSelectedProject(userSelectedProject));


    // Clear project-specific cached data
    sessionStorage.removeItem("selectedServer");
    sessionStorage.removeItem("selectedVolume");
    sessionStorage.removeItem("selectedVolumeSnapshot");
    sessionStorage.removeItem("selectedServerSnapshot");
    sessionStorage.removeItem("cart");

    clearInterval(progressInterval);
    setSwitchProgress(100);

   setTimeout(() => {
  setProjectSwitchingModal(false);
  window.location.reload();
}, 500);

  } catch (error) {
    clearInterval(progressInterval);
    setProjectSwitchingModal(false);

    console.error("Project switch failed:", error);

    toast.error(
      error?.response?.data?.statusmessage ||
      error?.response?.data?.message ||
      error?.message ||
      "Failed to switch project"
    );
  }
};

  const toggleServices = () => {
    setServiceVisible(true);
    setSmallScreenMenu(false);
  };

  const toggleBecomeAgentModal = () => {
    setBecomeAgentModal(!becomeAgentModal);
  };

  const toggleCreateWhiteLabelModal = () => {
    setCreateWhiteLabelModal(!createWhiteLabelModal);
    setServiceVisible(false);
  };

  const closeServices = () => {
    setServiceVisible(false);
  };

  const toggleProjects = async () => {
  setSelectedZone(null);
  setZoneProjects([]);
  setProjectsVisible(true);
  setSmallScreenMenu(false);

  if (zones.length === 0) {
    await fetchZones();
  }
};

  const closeProjects = () => {
  setProjectsVisible(false);
  setSelectedZone(null);
  setZoneProjects([]);
};

  const toggleSmallScreenMenu = () => {
    setSmallScreenMenu(true);
  };

  const closeSmallScreenMenu = () => {
    setSmallScreenMenu(false);
  };

  // Updated function to switch to partner admin using URL params
  const switchToPartnerAdmin = () => {
    switchToAdminMode();
  };

 const fetchZones = async () => {
  setZonesLoading(true);
  setZonesError('');

  try {
    const response = await apiEndPoints.listZones();
    const data = response?.data || response;

    const zoneList = Array.isArray(data)
      ? data
      : data?.zones ||
        data?.results ||
        data?.data ||
        [];

    setZones(Array.isArray(zoneList) ? zoneList : []);
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.statusmessage ||
      error?.message ||
      'Unable to load regions.';

    setZones([]);
    setZonesError(errorMessage);

    toast.error(errorMessage, {
      theme: 'colored',
      hideProgressBar: true,
      autoClose: 3000,
    });
  } finally {
    setZonesLoading(false);
  }
};

const handleZoneSelection = async (zone) => {
  const zoneId = zone?.id || zone?.zone_id;

  if (!zoneId) {
    toast.error('Unable to identify selected region.');
    return;
  }

  setSelectedZone(zone);
  setZoneProjects([]);
  setZoneProjectsLoading(true);

  try {
    const { payload } = await dispatch(
      listUserProjects({
        zoneId,
        setAsSelected: false,
      }),
    );

    const data = payload?.data || payload;

    const projects =
      data?.projects ||
      data?.results ||
      data?.data ||
      [];

    setZoneProjects(
      Array.isArray(projects) ? projects : [],
    );
  } catch (error) {
    const message =
      error?.response?.data?.statusmessage ||
      error?.response?.data?.message ||
      error?.message ||
      'Unable to load projects for this region.';

    toast.error(message);
  } finally {
    setZoneProjectsLoading(false);
  }
};

useEffect(() => {
  if (!addNewProjectDiv) return;

  fetchZones();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [addNewProjectDiv]);

const zoneOptions = [
  {
    value: '',
    label: zonesLoading ? 'Loading regions...' : 'Select a region',
  },
  ...zones.map((zone) => ({
    value: zone?.id || zone?.zone_id || '',
    label: zone?.name || zone?.zone_name || 'Unnamed region',
  })),
];

const getProjectZoneName = (project) =>
  project?.zone_name ||
  project?.zone?.name ||
  project?.zone_details?.name ||
  project?.zone?.zone_name ||
  project?.zoneName ||
  'Region unavailable';

  const createNewProject = useFormik({
  initialValues: {
    projectDescription: '',
    projectName: '',
    zoneId: '',
  },

  validationSchema: Yup.object({
    projectName: Yup.string().required(
      'Project Name cannot be empty',
    ),
    zoneId: Yup.string().required('Please select a region'),
  }),

  onSubmit: async (
    values,
    { resetForm, setSubmitting },
  ) => {
    const {
      projectName,
      projectDescription,
      zoneId,
    } = values;

    const createProjectData = {
      name: projectName,
      description: projectDescription,
      zone_id: zoneId,
    };

    try {
      setSubmitting(true);

      const { payload } = await dispatch(
        createProject({
          createProjectData,
          navigate,
        }),
      );

      if (payload?.statuscode === '00') {
        await dispatch(listUserProjects());

        resetForm();
        setAddNewProjectDiv(false);
        setProjectsVisible(true);
        navigate('/client-area');
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.statusmessage ||
        error?.response?.data?.message ||
        error?.message ||
        'Unable to create project.';

      toast.error(errorMessage);
    } finally {
      setSubmitting(false);
    }
  },
});

  const createWhiteLabelForm = useFormik({
    initialValues: {
      partnerName: '',
      description: '',
      logo: null,
    },
    validationSchema: Yup.object({
      partnerName: Yup.string()
        .required('Partner name is required')
        .matches(
          /^[a-z0-9-]+$/,
          'Partner name must be lowercase, alphanumeric, or hyphens only',
        ),
      description: Yup.string().required('Description is required'),
      logo: Yup.mixed()
        .nullable()
        .test('fileSize', 'Logo must be less than 5MB', (value) => {
          if (!value) return true;
          return value.size <= 5 * 1024 * 1024;
        })
        .test('fileType', 'Logo must be PNG, JPG, or JPEG', (value) => {
          if (!value) return true;
          return ['image/png', 'image/jpeg', 'image/jpg'].includes(value.type);
        }),
    }),
    onSubmit: async (values, { resetForm, setSubmitting }) => {
      try {
        setSubmitting(true);

        const formData = new FormData();
        formData.append('name', values.partnerName);
        formData.append('description', values.description);

        if (
          values.logo &&
          values.logo instanceof File &&
          values.logo.size > 0
        ) {
          formData.append('logo', values.logo);
        }

        const { payload } = await dispatch(createWhiteLabel(formData));

        if (payload.statuscode === '00') {
          toast.success('White-label partner created successfully!');
          resetForm();
          setCreateWhiteLabelModal(false);
          window.location.reload();
        } else {
          if (payload.errors) {
            Object.keys(payload.errors).forEach((field) => {
              if (Array.isArray(payload.errors[field])) {
                toast.error(`${field}: ${payload.errors[field][0]}`);
              } else {
                toast.error(`${field}: ${payload.errors[field]}`);
              }
            });
          }
        }
      } catch (error) {
        if (error.response?.data?.errors) {
          Object.keys(error.response.data.errors).forEach((field) => {
            const errorMsg = Array.isArray(error.response.data.errors[field])
              ? error.response.data.errors[field][0]
              : error.response.data.errors[field];
            toast.error(`${field}: ${errorMsg}`);
          });
        } else if (error.response?.data?.statusmessage) {
          toast.error(error.response.data.statusmessage);
        } else if (error.payload?.data?.statusmessage) {
          toast.error(error.payload.data.statusmessage);
        } else {
          toast.error(
            'An error occurred while creating the white-label partner',
          );
        }
      } finally {
        setSubmitting(false);
      }
    },
  });

  const handleFileChange = (event) => {
    const file = event.currentTarget.files[0];

    if (file) {
      const isValidType = ['image/png', 'image/jpeg', 'image/jpg'].includes(
        file.type,
      );
      const isValidSize = file.size <= 5 * 1024 * 1024;

      if (!isValidType) {
        toast.error('Please select a PNG, JPG, or JPEG file');
        event.target.value = '';
        return;
      }

      if (!isValidSize) {
        toast.error('File size must be less than 5MB');
        event.target.value = '';
        return;
      }

      createWhiteLabelForm.setFieldValue('logo', file);
    } else {
      createWhiteLabelForm.setFieldValue('logo', null);
    }

    createWhiteLabelForm.setFieldTouched('logo', true);
  };

  const [dropdownStates, setDropdownStates] = useState({});

  const toggleDropdown = (label) => {
    setDropdownStates((prev) => ({ ...prev, [label]: !prev[label] }));
  };

  // Import sidebar items structure from sideBar.js
  const sidebarItems = [
    {
      path: '/client-area',
      label: 'Resources',
      icon: resources,
    },
    {
      path: '/client-area/manage',
      label: 'Manage project',
      icon: manage,
    },
    {
      path: '/manageServerSnapshots',
      label: 'Server snapshots',
      iconComponent: <ServerCrash className="text-primaryBlue h-4 w-4" />,
    },
    {
      label: 'Volumes',
      iconComponent: <Database className="text-primaryBlue h-4 w-4" />,
      sublinks: [
        { path: '/client-area/volumes', label: 'Volumes' },
        { path: '/manageVolumeSnapshots', label: 'Volume Snapshots' },
        { path: '/manageVolumeBackups', label: 'Volume Backups' },
      ],
    },
    {
      label: 'Networks',
      iconComponent: <Globe className="text-primaryBlue h-4 w-4" />,
      sublinks: [
        { path: '/networks', label: 'Networks' },
        { path: '/securityGroups', label: 'Security groups' },
        { path: '/routers', label: 'Routers' },
        { path: '/floating-ips', label: 'Floating IPs' },
        { path: '/manageLoadBalancers', label: 'Load Balancers' },
      ],
    },
    {
      path: '/certificate-manager',
      label: 'Certificate Manager',
      iconComponent: <FileLock2 className="text-primaryBlue h-4 w-4" />,
    },
    {
      label: 'Billing',
      icon: billing,
      path: '/billing',
    },
    {
      path: '/help',
      label: 'Support',
      icon: support,
    },
    {
      path: '/help',
      label: 'Payment dispute',
      iconComponent: <Handshake className="text-primaryBlue h-4 w-4" />,
      onClick: () => sessionStorage.setItem('supportType', 'payment-dispute'),
    },
    {
      path: '/event-logs',
      label: 'Event Logs',
      iconComponent: <Logs className="text-primaryBlue h-4 w-4" />,
    },
    {
      label: 'Settings',
      icon: setting,
      sublinks: [
        { path: '/settings/profile', label: 'Profile' },
        { path: '/settings/account', label: 'Account' },
        { path: '/settings/security', label: 'Security' },
      ],
    },
  ];

  // Simplified function using the context function
  const switchToPartner = () => {
    setShowPartnerAdminModal(true);
  };

  return (
    <div className="relative">
      <Spinner loading={useSelector((state) => state.user).loading} />
      <div className="bg-white py-4 px-4 md:pe-10 dark:bg-[#141D26] border-b dark:border-b-[#c4c4c432] dark:text-white">
        <div className="flex items-center justify-between">
          <div className='flex gap-6 items-center'>
            <Link to={'/client-area'}>
              <img
                src={theme === 'dark' ? WhiteLogoIcon : LogoIcon}
                alt=""
                className="hidden lg:block h-[18px]"
              />
            </Link>
            <Link to={'/client-area'}>
              <img
                src={theme === 'dark' ? WhiteIcon : icon}
                alt=""
                className="lg:hidden h-6"
              />
            </Link>
          </div>
          <div className="flex gap-3 items-center justify-between">
            <div className="md:hidden" onClick={toggleSmallScreenMenu}>
              <img src={hamburger} alt="" className="h-5" />
            </div>

           <div className="hidden md:flex gap-2 text-sm items-center px-3 py-2 relative">
          <div className="min-w-0">
            <p className="font-medium truncate">  {selectedProject?.name || ''} </p>
            {selectedProject && (
              <p className="text-[10px] text-gray-500 dark:text-gray-400 truncate">
                {getProjectZoneName(selectedProject)}
              </p>
            )}
          </div>

          <div>
        <span
          onClick={toggleProjects}
          className="text-xs text-primaryBlue cursor-pointer"
        >
          [Switch Region]
        </span>

 {projectsVisible && (
<div className="absolute top-full left-0 mt-3 z-[9999] w-[280px]">
    <div className="bg-white dark:bg-[#141D26] rounded-md shadow-xl border dark:border-[#c4c4c432] max-h-[65vh] overflow-auto">

      <div className="sticky top-0 z-10 bg-white dark:bg-[#141D26] flex justify-between items-center text-sm px-4 py-4 border-b dark:border-b-[#c4c4c432]">
        <div className="flex gap-2 items-center">
          <img
            src={projectsFolder}
            alt=""
            className="h-4"
          />

          <span className="font-medium">
            {selectedZone
              ? selectedZone?.name ||
                selectedZone?.zone_name ||
                'Projects'
              : 'Available Regions'}
          </span>
        </div>

        <img
          src={close}
          onClick={closeProjects}
          className="h-4 cursor-pointer"
          alt="Close"
        />
      </div>

      <div className="grid text-xs px-3 pb-3 pt-1">
        {!selectedZone && (
          <>
            {zonesLoading ? (
              <div className="py-8 text-center text-gray-500">
                Loading regions...
              </div>
            ) : (
              zones.map((zone, key) => {
                const zoneId =
                  zone?.id ||
                  zone?.zone_id ||
                  key;

                const zoneName =
                  zone?.name ||
                  zone?.zone_name ||
                  'Unnamed region';

                return (
                  <div
                    key={zoneId}
                    onClick={() =>
                      handleZoneSelection(zone)
                    }
                    className="flex items-center justify-between border-b dark:border-[#c4c4c424] py-3 px-2 hover:bg-primaryBlue/5 cursor-pointer"
                  >
                    <div>
                      <p className="font-medium text-sm">
                        {zoneName}
                      </p>

                      <p className="text-[10px] text-gray-500 dark:text-gray-400 mt-0.5">
                        View projects in this region
                      </p>
                    </div>

                    <img
                      src={arrow}
                      alt=""
                      className="-rotate-90 h-3"
                    />
                  </div>
                );
              })
            )}
          </>
        )}

        {selectedZone && (
          <>
            <button
              type="button"
              onClick={() => {
                setSelectedZone(null);
                setZoneProjects([]);
              }}
              className="text-primaryBlue text-xs py-3 px-2 text-left"
            >
              ← Back to regions
            </button>

            {zoneProjectsLoading ? (
              <div className="py-8 text-center text-gray-500">
                Loading projects...
              </div>
            ) : (
              zoneProjects.map((val, key) => (
                <div
                  key={val.id || val.uuid || key}
                  onClick={() =>
                    handleProjectSelection(val)
                  }
                  className="flex items-center justify-between border-b dark:border-[#c4c4c424] py-3 px-2 hover:bg-primaryBlue/5 cursor-pointer"
                >
                  <div className="min-w-0">
                    <p className="font-medium truncate">
                      {val.name}
                    </p>

                    <p className="text-[10px] text-gray-500 dark:text-gray-400 truncate">
                      {selectedZone?.name ||
                        selectedZone?.zone_name}
                    </p>
                  </div>

                  <img
                    src={arrow}
                    alt=""
                    className="-rotate-90 h-3"
                  />
                </div>
              ))
            )}
          </>
        )}
      </div>
    </div>
  </div>
)}

      </div>
        </div>
            <div
              onClick={toggleServices}
              className="hidden md:flex text-sm items-center px-3 py-2 cursor-pointer"
            >
              <span>Services</span>
            </div>
            <Link
              to={'/faq'}
              className="hidden md:block text-sm px-3 py-2 cursor-pointer"
            >
              <span>FAQs</span>
            </Link>

            <div className="hidden xl:block w-px h-5 bg-black/15 dark:bg-white/15 mx-1.5" />
            <ThemeToggler />
            {/* Desktop divider */}
            <div className="hidden xl:block w-px h-5 bg-black/15 dark:bg-white/15 mx-1.5" />

            {userSessionData && userSessionData?.partner?.active && (
              <div
                className="hidden md:flex items-center justify-center cursor-pointer rounded font-medium lg:text-[#1DA1F2] border border-[#1DA1F2]/30 bg-primaryBlue/5 transition-all py-2 lg:py-3 px-3 lg:px-4 text-sm"
                onClick={switchToPartner}
              >
                View Partner Dashboard
              </div>
            )}
            <Link
              to={'/client-area/configure-vps'}
              className="flex gap-[10px] items-center bg-[#1DA1F2] rounded p-2 md:p-[14px]"
            >
              <img src={cart} alt="" className="h-4" />
              <span className="text-xs text-white">
                {totalPrice > 0
                  ? `${currency === 'USD' ? 'USD ' : '₦ '}${totalPrice.toLocaleString()}`
                  : '0'}
              </span>
            </Link>
          </div>
        </div>
      </div>

      {showPartnerAdminModal && (
        <div className="w-full fixed h-screen bg-black/70 top-0 px-4 flex items-end md:items-center justify-center">
          <div className="bg-white dark:bg-[#141D26] rounded w-full md:w-[40%] dark:text-white max-h-[80%] mb-4 md:mb-0 overflow-auto p-4 md:p-6 border-y-[16px] dark:border-y-[#141d26]">
            <div
              onClick={() => setShowPartnerAdminModal(false)}
              className="cursor-pointer mb-4 text-right text-[#c4c4c4]"
            >
              [Close]
            </div>
            <div className="grid gap-4 text-sm mb-6">
              <span className="font-bold text-md">Access Partner Panel</span>
              <span>
                Switch to your partner panel to manage your pricing, view
                analytics, and configure your white-label settings.
              </span>
            </div>
            <div className="flex gap-4">
              <button
                onClick={switchToPartnerAdmin}
                className="py-4 px-10 rounded-md text-white text-sm bg-[#1DA1F2]"
              >
                Go to Partner Panel
              </button>
              <button
                onClick={() => setShowPartnerAdminModal(false)}
                className="py-4 px-10 rounded-md border dark:border-[#c4c4c432] text-sm"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {serviceVisible && (
        <div className="w-full fixed h-screen bg-black/70 top-0 px-4 flex items-end md:items-center justify-center">
          <div className="bg-white dark:bg-[#141D26] rounded w-full md:w-1/2 lg:w-2/5 dark:text-white max-h-[80%] mb-4 md:mb-0 overflow-auto">
            <div className="flex justify-between items-center text-sm p-6 border-b dark:border-b-[#c4c4c432]">
              <div className="flex gap-2 items-center">
                <img src={menuBrand} alt="" className="h-[18px]" />
                <span>Services</span>
              </div>
              <img
                src={close}
                onClick={closeServices}
                className="h-5 cursor-pointer"
                alt=""
              />
            </div>
            <div className="grid text-xs px-4 pb-4 pt-2">
              <Link
                to={'/client-area/vps'}
                onClick={closeServices}
                className="flex items-center justify-between hover:rounded border-b dark:border-[#c4c4c424] last:border-none py-4 px-3 hover:bg-primaryBlue/5 transition-all"
              >
                <span>Create dews</span>
                <span>
                  <img src={arrow} alt="" className="-rotate-90" />
                </span>
              </Link>
              <Link
                to={'/client-area/volumes'}
                onClick={closeServices}
                className="flex items-center justify-between hover:rounded border-b dark:border-[#c4c4c424] last:border-none py-4 px-3 hover:bg-primaryBlue/5 transition-all"
              >
                <span>Manage volumes</span>
                <span>
                  <img src={arrow} alt="" className="-rotate-90" />
                </span>
              </Link>
              <Link
                to={'/manageLoadBalancers'}
                onClick={closeServices}
                className="flex items-center justify-between hover:rounded border-b dark:border-[#c4c4c424] last:border-none py-4 px-3 hover:bg-primaryBlue/5 transition-all"
              >
                <span>Load balancers</span>
                <span>
                  <img src={arrow} alt="" className="-rotate-90" />
                </span>
              </Link>
              {/* <div
                onClick={toggleCreateWhiteLabelModal}
                className="flex items-center justify-between hover:rounded border-b dark:border-[#c4c4c424] last:border-none py-4 px-3 hover:bg-primaryBlue/5 transition-all cursor-pointer"
              >
                <span>White Label</span>
                <span>
                  <img src={arrow} alt="" className="-rotate-90" />
                </span>
              </div> */}
            </div>
          </div>
        </div>
      )}

      {/* {projectsVisible && (
        <div className="w-full fixed h-screen bg-black/70 top-0 px-4 flex items-end md:items-center justify-center">
          <div className="bg-white dark:bg-[#141D26] rounded w-full md:w-[30%] dark:text-white max-h-[80%] mb-4 md:mb-0 overflow-auto">
            <div className="flex justify-between items-center text-sm p-6 border-b dark:border-b-[#c4c4c432]">
              <div className="flex gap-2 items-center">
                <img src={projectsFolder} alt="" className="h-[18px]" />
                <span className="dark:text-white">My projects</span>
              </div>
              <img
                src={close}
                onClick={closeProjects}
                className="h-5 cursor-pointer"
                alt=""
              />
            </div>
            <div className="grid text-xs px-4 pb-4 pt-2">
              {userProjectList &&
                userProjectList.length > 0 &&
                userProjectList.map((val, key) => {
                  return (
                   <div
                  key={val.id || val.uuid || key}
                  onClick={() => {
                    handleProjectSelection(val);
                  }}
                  className="flex items-center justify-between hover:rounded border-b dark:border-[#c4c4c424] last:border-none py-4 px-3 hover:bg-primaryBlue/5 transition-all cursor-pointer"
                >
                  <div className="min-w-0">
                    <p className="font-medium truncate">
                      {val.name}
                    </p>

                    <p className="text-[11px] text-gray-500 dark:text-gray-400 truncate">
                      {getProjectZoneName(val)}
                    </p>
                  </div>

                  <span>
                    <img
                      src={arrow}
                      alt=""
                      className="-rotate-90"
                    />
                  </span>
                </div>
                  );
                })}

              <div
                onClick={() => {
                  setAddNewProjectDiv(true);
                  setProjectsVisible(false);
                }}
                className="flex items-center justify-between bg-primaryBlue py-4 px-3 mt-4 rounded-md cursor-pointer"
              >
                <span>Create a new project</span>
                <img src={add} alt="" className="h-5" />
              </div>
            </div>
          </div>
        </div>
      )} */}



      {projectSwitchingModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm">
          <div className="bg-white dark:bg-[#141D26] rounded-2xl w-full max-w-md mx-4 p-8 shadow-2xl">
            {/* Header */}
            <div className="text-center mb-8">
              <div className="mx-auto w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center mb-4 animate-pulse">
                <svg
                  className="w-8 h-8 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                  />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
                Switching Region
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                Switching to{' '}
                <span className="font-medium text-blue-600 dark:text-blue-400">
                  {switchingProjectName}
                </span>
              </p>
            </div>

            {/* Progress Bar */}
            <div className="space-y-3">
              <div className="relative h-3 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
                <div
                  className="absolute top-0 left-0 h-full bg-gradient-to-r from-blue-500 to-blue-600 rounded-full transition-all duration-300 ease-out"
                  style={{ width: `${switchProgress}%` }}
                >
                  <div className="absolute inset-0 bg-white/30 animate-pulse"></div>
                </div>
              </div>
              <div className="flex justify-between items-center text-xs">
                <span className="text-gray-600 dark:text-gray-400">
                  {switchProgress < 100 ? 'Please wait...' : 'Complete!'}
                </span>
                <span className="font-semibold text-blue-600 dark:text-blue-400">
                  {Math.round(switchProgress)}%
                </span>
              </div>
            </div>

            {/* Loading Animation */}
            <div className="mt-6 flex justify-center space-x-1">
              <div
                className="w-2 h-2 bg-blue-500 rounded-full animate-bounce"
                style={{ animationDelay: '0ms' }}
              ></div>
              <div
                className="w-2 h-2 bg-blue-500 rounded-full animate-bounce"
                style={{ animationDelay: '150ms' }}
              ></div>
              <div
                className="w-2 h-2 bg-blue-500 rounded-full animate-bounce"
                style={{ animationDelay: '300ms' }}
              ></div>
            </div>
          </div>
        </div>
      )}

      {smallScreenMenu && (
        <div className="w-full fixed h-screen bg-black/70 top-0 px-4 flex items-end justify-center">
          <div className="bg-white dark:bg-[#141D26] rounded w-full dark:text-white max-h-[80%] mb-4 md:mb-0 overflow-auto">
            <div className="flex sticky top-0 bg-white dark:bg-[#141D26] z-50 justify-between items-center text-sm p-6 border-b dark:border-b-[#c4c4c432]">
              <div className="flex gap-2 items-center">
                <img src={menuBrand} alt="" className="h-[18px]" />
                <span className="dark:text-white">Menu</span>
              </div>
              <img
                src={close}
                onClick={closeSmallScreenMenu}
                className="h-5 cursor-pointer"
                alt=""
              />
            </div>
            <div className="grid text-xs px-4 pb-4 pt-2">
              {/* Keep the Become an agent item */}
              <Link
                to={'/client-area'}
                onClick={() => {
                  toggleBecomeAgentModal();
                  closeSmallScreenMenu();
                }}
                className="flex items-center justify-between hover:rounded border-b dark:border-[#c4c4c424] last:border-none py-4 px-3 hover:bg-primaryBlue/5 transition-all"
              >
                <span>Become an agent</span>
                <span>
                  <img src={arrow} alt="" className="-rotate-90" />
                </span>
              </Link>

              {/* Render sidebar items */}
              {sidebarItems.map((item, index) => {
                if (item.sublinks) {
                  const isOpen = dropdownStates[item.label] || false;
                  return (
                    <div key={index} className="grid">
                      <div
                        className={`flex items-center justify-between hover:rounded border-b dark:border-[#c4c4c424] last:border-none py-4 px-3 hover:bg-primaryBlue/5 transition-all cursor-pointer`}
                        onClick={() => toggleDropdown(item.label)}
                      >
                        <div className="text-center truncate">{item.label}</div>
                        <img
                          src={arrow}
                          alt=""
                          className={`h-8 ml-auto transition-transform ${isOpen ? 'rotate-360' : '-rotate-90'}`}
                        />
                      </div>
                      {isOpen && (
                        <div className="ml-6 space-y-[1px] grid">
                          {item.sublinks.map((sublink, subIndex) => (
                            <Link
                              key={subIndex}
                              to={sublink.path}
                              onClick={() => {
                                if (sublink.onClick) {
                                  sublink.onClick();
                                }
                                closeSmallScreenMenu();
                              }}
                              className="flex items-center justify-between hover:rounded border-b dark:border-[#c4c4c424] last:border-none py-4 px-3 hover:bg-primaryBlue/5 transition-all"
                            >
                              <div className="pl-4">
                                <div className="text-center truncate">
                                  {sublink.label}
                                </div>
                              </div>
                            </Link>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                } else {
                  return (
                    <Link
                      key={index}
                      to={item.path}
                      onClick={() => {
                        if (item.onClick) {
                          item.onClick();
                        }
                        closeSmallScreenMenu();
                      }}
                      className="flex items-center justify-between hover:rounded border-b dark:border-[#c4c4c424] last:border-none py-4 px-3 hover:bg-primaryBlue/5 transition-all"
                    >
                      <span>{item.label}</span>
                      <span>
                        <img src={arrow} alt="" className="-rotate-90" />
                      </span>
                    </Link>
                  );
                }
              })}

              {/* Sign out link */}
              <Link
                to={'/sign-out'}
                onClick={closeSmallScreenMenu}
                className="flex items-center justify-between hover:rounded border-b dark:border-[#c4c4c424] last:border-none py-4 px-3 hover:bg-primaryBlue/5 transition-all"
              >
                <span>Sign out</span>
                <span>
                  <img src={logout} alt="" className="-rotate-90" />
                </span>
              </Link>
            </div>
          </div>
        </div>
      )}

      {addNewProjectDiv && (
        <div className="fixed top-0 h-screen w-full z-50 bg-black/60 backdrop-blur-md flex items-center justify-center p-4">
          <div className="bg-white dark:bg-[#141D26] rounded-md p-4 md:p-10 w-full md:w-1/3">
            <div className="flex items-center justify-between mb-4">
              <p className="text-primaryBlue">Create a new project</p>
              <span
                onClick={() => {
                  setAddNewProjectDiv(false);
                  setProjectsVisible(true);
                }}
                className="cursor-pointer"
              >
                <img alt="" src={close} className="h-5" />
              </span>
            </div>
            <form
              className="gap-y-6 grid"
              onSubmit={createNewProject.handleSubmit}
            >
              <Input
                label={'Project name'}
                type={'text'}
                name={'projectName'}
                value={createNewProject.values.projectName}
                onBlur={createNewProject.handleBlur}
                onChange={createNewProject.handleChange}
                onError={
                  createNewProject.errors.projectName &&
                  createNewProject.touched.projectName
                    ? createNewProject.errors.projectName
                    : null
                }
              />
              <TextArea
                label={'Description'}
                type={'text'}
                noOfRow={'3'}
                name={'projectDescription'}
                value={createNewProject.values.projectDescription}
                onBlur={createNewProject.handleBlur}
                onChange={createNewProject.handleChange}
                onError={
                  createNewProject.errors.projectDescription &&
                  createNewProject.touched.projectDescription
                    ? createNewProject.errors.projectDescription
                    : null
                }
              />
              <Select
                    label="Region"
                    name="zoneId"
                    options={zoneOptions}
                    valueKey="value"
                    labelKey="label"
                    value={createNewProject.values.zoneId}
                    onChange={createNewProject.handleChange}
                    onBlur={createNewProject.handleBlur}
                    disabled={zonesLoading}
                    onError={
                      createNewProject.errors.zoneId &&
                      createNewProject.touched.zoneId
                        ? createNewProject.errors.zoneId
                        : null
                    }
                  />

                  {zonesError && (
                    <div className="flex items-center justify-between gap-3">
                      <p className="text-xs text-red-500">
                        {zonesError}
                      </p>

                      <button
                        type="button"
                        onClick={fetchZones}
                        disabled={zonesLoading}
                        className="text-xs text-primaryBlue hover:underline disabled:opacity-50"
                      >
                        {zonesLoading ? 'Retrying...' : 'Retry'}
                      </button>
                    </div>
                  )}
              <div className="flex justify-between items-center gap-2">
                <Button buttonText={
            createNewProject.isSubmitting ? 'Creating...' : 'Create Project' }
          buttonRole="submit"
          disabled={ createNewProject.isSubmitting || zonesLoading || zones.length === 0
          }
        />
              </div>
            </form>
          </div>
        </div>
      )}

      {createWhiteLabelModal && (
        <div className="fixed top-0 h-screen w-full left-0 z-50 bg-black/60 flex items-center justify-center p-4">
          <div className="bg-white dark:bg-[#141D26] rounded-md p-4 md:p-10 w-full md:w-1/3 max-h-[80%] overflow-y-scroll">
            <div className="flex items-center justify-between mb-4">
              <p className="text-primaryBlue">Create White-Label Partner</p>
              <span
                onClick={() => {
                  setCreateWhiteLabelModal(false);
                  setServiceVisible(true);
                }}
                className="cursor-pointer"
              >
                <img alt="" src={close} className="h-5" />
              </span>
            </div>
            <form
              className="gap-y-6 grid"
              onSubmit={createWhiteLabelForm.handleSubmit}
            >
              <Input
                label={'Partner Name (Subdomain)'}
                type={'text'}
                name={'partnerName'}
                value={createWhiteLabelForm.values.partnerName}
                onBlur={createWhiteLabelForm.handleBlur}
                onChange={createWhiteLabelForm.handleChange}
                onError={
                  createWhiteLabelForm.errors.partnerName &&
                  createWhiteLabelForm.touched.partnerName
                    ? createWhiteLabelForm.errors.partnerName
                    : null
                }
                placeholder={'e.g., swan'}
              />
              <TextArea
                label={'Description'}
                type={'text'}
                noOfRow={'3'}
                name={'description'}
                value={createWhiteLabelForm.values.description}
                onBlur={createWhiteLabelForm.handleBlur}
                onChange={createWhiteLabelForm.handleChange}
                onError={
                  createWhiteLabelForm.errors.description &&
                  createWhiteLabelForm.touched.description
                    ? createWhiteLabelForm.errors.description
                    : null
                }
              />
              <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Logo (Optional)
                </label>
                <div className="relative">
                  <input
                    type="file"
                    name="logo"
                    id="logo-upload"
                    className="sr-only"
                    accept="image/png,image/jpeg,image/jpg"
                    onChange={handleFileChange}
                  />
                  <label
                    htmlFor="logo-upload"
                    className={`relative flex flex-col items-center justify-center w-full h-32 border-2 border-dashed rounded-xl cursor-pointer transition-all duration-300 hover:bg-gray-50 dark:hover:bg-gray-800/50 ${
                      createWhiteLabelForm.values.logo
                        ? 'border-green-400 bg-green-50 dark:bg-green-900/20'
                        : 'border-gray-300 dark:border-gray-600 hover:border-gray-400 dark:hover:border-gray-500'
                    } ${
                      createWhiteLabelForm.errors.logo &&
                      createWhiteLabelForm.touched.logo
                        ? 'border-red-400 bg-red-50 dark:bg-red-900/20'
                        : ''
                    }`}
                  >
                    {createWhiteLabelForm.values.logo ? (
                      <div className="flex flex-col items-center space-y-2">
                        <div className="flex items-center justify-center w-12 h-12 bg-green-100 dark:bg-green-800 rounded-full">
                          <svg
                            className="w-6 h-6 text-green-600 dark:text-green-400"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M5 13l4 4L19 7"
                            />
                          </svg>
                        </div>
                        <div className="text-center">
                          <p className="text-sm font-medium text-green-600 dark:text-green-400">
                            {createWhiteLabelForm.values.logo.name}
                          </p>
                          <p className="text-xs text-gray-500 dark:text-gray-400">
                            {(
                              createWhiteLabelForm.values.logo.size /
                              1024 /
                              1024
                            ).toFixed(2)}{' '}
                            MB
                          </p>
                        </div>
                        <button
                          type="button"
                          onClick={(e) => {
                            e.preventDefault();
                            createWhiteLabelForm.setFieldValue('logo', null);
                          }}
                          className="text-xs text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-300 underline"
                        >
                          Remove file
                        </button>
                      </div>
                    ) : (
                      <div className="flex flex-col items-center space-y-2">
                        <div className="flex items-center justify-center w-12 h-12 bg-gray-100 dark:bg-gray-700 rounded-full">
                          <svg
                            className="w-6 h-6 text-gray-400 dark:text-gray-500"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                            />
                          </svg>
                        </div>
                        <div className="text-center">
                          <p className="text-sm font-medium text-gray-700 dark:text-gray-300">
                            Click to upload or drag and drop
                          </p>
                          <p className="text-xs text-gray-500 dark:text-gray-400">
                            PNG, JPG, JPEG up to 5MB
                          </p>
                        </div>
                      </div>
                    )}

                    {/* Hover overlay */}
                    <div className="absolute inset-0 bg-blue-500 bg-opacity-10 rounded-xl opacity-0 hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                      <div className="bg-white dark:bg-gray-800 rounded-lg px-3 py-1 shadow-lg">
                        <p className="text-xs font-medium text-gray-700 dark:text-gray-300">
                          {createWhiteLabelForm.values.logo
                            ? 'Change file'
                            : 'Select file'}
                        </p>
                      </div>
                    </div>
                  </label>
                </div>
                {createWhiteLabelForm.errors.logo &&
                  createWhiteLabelForm.touched.logo && (
                    <div className="flex items-center space-x-1 text-red-600 dark:text-red-400">
                      <svg
                        className="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                      <p className="text-sm">
                        {createWhiteLabelForm.errors.logo}
                      </p>
                    </div>
                  )}
              </div>
              <div className="flex justify-between items-center gap-2">
                <Button
                  buttonText={loading ? 'Creating...' : 'Create White-Label'}
                  buttonRole={'submit'}
                  disabled={loading}
                />
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default TopBar;
